import { CurrentUser } from '@/models/user.model';
import { api } from '@/services/api/index';

export const authApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getCurrentUser: builder.query<CurrentUser, void>({
      query: () => ({
        url: '/v1/users/me',
        method: 'GET'
      }),
      providesTags: (result) =>
        result
          ? [
              { type: 'User', id: 'current' },
              { type: 'User', id: result.id }
            ]
          : []
    }),
    updateCurrentUserPassword: builder.mutation<void, { password: string }>({
      query: (data) => ({
        url: '/v1/users/me/password',
        data: data,
        method: 'PATCH'
      })
    })
  })
});

export const { useGetCurrentUserQuery, useUpdateCurrentUserPasswordMutation } =
  authApi;
